import axios from "axios";
import store from "../redux/store";
import { signOut } from "../redux/slices/userSlice";

export const handleSignout = async () => {
    try {
      await axios.post("/business/account/signout");
    } catch (error) {}
    sessionStorage.clear();
    localStorage.clear();
    store.dispatch(signOut());
};

// Get nested object keys safely  (can really be used for anything that may fail and needs a default value)
//    func: () => someObject.some[works_with_arrays].nested.properties;
//    defaultValue: return this value if object path does not exist




export const getSafe = (func, defaultValue = "") => {
    try {
        if (func()) return func();
        else return defaultValue;
    }
    catch (error) {
        return defaultValue;
    }
}


